/**
 * @ngdoc directive
 * @module components.pagination
 * @name components.pagination:paginationFilter
 * @requires pagination
 * @restrict E
 * @description
 * Filters paginated content. Must be nested within the pagination component
 * @param {string} param The name of the key that is passed to the pagination logic.
 * @param {string=} default The default value of the filter (not implemented yet).
 * @param {promise=} promise A promise that delays initialization of the filter. Used when the content of the filter is loaded asynchronously.
 * @param {function=} onUpdate Callback function that is triggered when the filter changes Passes the following fields to the function.
 * - key: the param the filter is tied to
 * - value: the filter's current value
 * @example
    <example module="example">
        <file name="index.html">
            <div>
                <pagination service="global.blogPosts">
                    <pagination-filter param="searchTerm">
                        <form class="one-line" ng-submit="$ctrl.updateFilterParam(true)">
                            <input type="text" placeholder="Search Blog" />
                            <label class="button">
                                <input type="submit" />
                                <i class="fa fa-search-flat"></i>
                            </label>
                        </form>
                    </pagination-filter>
                    <ul>
                        <li ng-repeat="post in $ctrl.items">
                            <h3>{{post.name}}</h3>
                            <p>{{post.excerpt}}</p>
                        </li>
                    </ul>
                </pagination>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('example', ['components.pagination', 'services.global'])
            })();
        </file>
    </example>
 */

(function () {
    angular.module('components.pagination')
        .component('paginationFilter', {
            require: {
                pagination: '^pagination'
            },
            bindings: {
                param: '@',
                promise: '<?', //used when filter content is loaded asyncronously
                delay: '<?',
                onUpdate: '&'
            },
            transclude: true,
            controller: paginationFilterController
        });

    paginationFilterController.$inject = ['$element', '$scope', '$transclude', '$compile', '$timeout'];
    function paginationFilterController($element, $scope, $transclude, $compile, $timeout) {
        var ctrl = this;
        ctrl.$$initalizeContent = function () {
            ctrl.value = ctrl.pagination.getParam(ctrl.param);
            ctrl.$$initialLoad = true;
            if (!ctrl.delay) {
                ctrl.delay = 0;
            }
            $transclude(function (clone, scope) {
                $element.empty().html(clone);
                $timeout(function () {
                    var inputs = $element.find('input, select');
                    if (inputs.is('[type="checkbox"]')) {
                        if (!ctrl.value) {
                            ctrl.value = [];
                        }
                        var result = [];
                        for (var i = 0; i < inputs.length; i++) {
                            var input = angular.element(inputs[i]);
                            var val = input.attr("ng-true-value").replace(/'/g, '');
                            result[i] = ctrl.value.indexOf(val) > -1 ? val : false;
                            input.attr('ng-model', '$ctrl.value[' + i + ']');
                        }
                        ctrl.value = result;
                    }
                    else if (inputs.is('[type="radio"]')) {
                        for (var i = 0; i < inputs.length; i++) {
                            var input = angular.element(inputs[i]);
                            input.attr('ng-model', '$ctrl.value');
                        }
                    }
                    else {
                        inputs.attr('ng-model', '$ctrl.value');
                    }
                    if (!$element.find('[ng-submit]').length) {
                        $scope.$watch('$ctrl.value', function (value) {
                            if (!ctrl.$$initialLoad) {
                                $timeout.cancel(ctrl.$updateTimer);
                                ctrl.$updateTimer = $timeout(ctrl.updateFilterParam, ctrl.delay)
                            }
                            ctrl.$$initialLoad = false;
                        }, true)
                    }
                    var repeaters = $element.find('[ng-repeat]');
                    if (repeaters.length) {
                        repeaters.removeAttr('ng-repeat')
                    }
                    $compile($element.contents())($scope);
                });
            });
        }

        ctrl.$onInit = function () {
            if (ctrl.promise) {
                ctrl.promise.then(ctrl.$$initalizeContent);
            }
            else {
                ctrl.$$initalizeContent();
            }
        }
        /**
         * @ngdoc method
         * @name paginationFilter#updateFilterParam
         * @methodOf components.pagination:paginationFilter
         * @description
         * Processes the filter's current value into what is expected and passes that value to the pagination component. Can be used inside ng-submit to only trigger the update on form submission.
         * @param {bool=} reset Clears the value of the filter after the update is passed to the pagination. Used to clear filter forms after submission.
         */
        ctrl.updateFilterParam = function (reset) {
            var val = angular.copy(ctrl.value);
            if (Array.isArray(val)) {
                var result = [];
                for (var i = 0; i < val.length; i++) {
                    var v = val[i];
                    if (v === 0 || !!v)
                        result.push(v);
                }
                val = result;
            }
            ctrl.pagination.updateParam(ctrl.param, val);
            if (ctrl.onUpdate)
                ctrl.onUpdate({ key: ctrl.param, value: val });
            if (reset)
                ctrl.value = undefined;
        }

        /**
         * @ngdoc method
         * @name paginationFilter#clearFilter
         * @methodOf components.pagination:paginationFilter
         * @description
         * Clears the value of the filter parameter.
         */
        ctrl.clearFilter = function () {
            ctrl.value = undefined;
        }
    }
})();